export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/employees/state.js